import { createRouter } from '@tanstack/react-router';
import { onUnauthorized } from './api/auth';
import { queryClient } from './api/query-client';
import { queryKeys } from './api/query-keys';
import { routeTree } from './routeTree.gen';

export const router = createRouter({
  routeTree,
  context: { queryClient },
  // Warm data and code on hover/touch, which hides most of the navigation cost.
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

/**
 * The API layer reports a rejected session; deciding where the player goes is the
 * router's business. Player-scoped cache is dropped so no stale balance survives.
 */
onUnauthorized(() => {
  queryClient.removeQueries({ queryKey: queryKeys.player.all });
  queryClient.removeQueries({ queryKey: queryKeys.tickets.all });
  queryClient.removeQueries({ queryKey: queryKeys.casino.all });
  queryClient.removeQueries({ queryKey: queryKeys.cms.all });
  queryClient.removeQueries({ queryKey: queryKeys.betslip.all });
  void router.navigate({ to: '/login', search: { redirect: router.state.location.href } });
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
